import { GenericModel } from '@nsk-app/models/genericModel';

export class ActionMoment extends GenericModel {

  action_type: ActionType;
  action_value: string;
  caption: string;

}

export enum ActionType {
  URL = 1,
  Mail = 2,
  Phone = 3,
  Contact = 5,
  Settings = 6,
  Location = 7,
  Date = 8
}
